import React from 'react';
import { Layout, Typography } from 'antd';
import { TreeView } from '../components/library/tree-view';
import BannerGrid from '../components/library/banner-viewer';
import { useResponsiveSizes } from '../hooks/use-responsive-sizes';

const { Sider, Content } = Layout;
const { Title } = Typography;

const LibraryContent: React.FC = () => {
  const { screens } = useResponsiveSizes();

  return (
    <Layout style={{ display: 'flex', gap: screens.md ? '24px' : 0 }}>
      {/* Sidebar solo en desktop */}
      {screens.md && (
        <Sider width={350} theme='light' style={{ padding: '13px 24px' }}>
          <TreeView />
        </Sider>
      )}
      <Content style={{ padding: screens.md ? '13px' : '13px 0' }}>
        <BannerGrid />
      </Content>
    </Layout>
  );
};

export const LibraryPage: React.FC = () => {
  const { fontSize, spacing, screens } = useResponsiveSizes();

  return (
    <div style={{ maxWidth: '100%', margin: `0 ${screens.xs ? spacing.md : spacing.xxl}px` }}>
      <Title style={{ fontSize: fontSize.xxxl, marginBottom: spacing.md, display: 'flex' }}>Library</Title>
      <LibraryContent />
    </div>
  );
};
